import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Row, Input } from 'reactstrap';
import { Field } from 'redux-form';
import renderSelectField from '../../../../../../shared/components/form/Select';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import history from '../../../../../../history';
import PrintsProceduresPDF from '../PrintsProceduresPDF';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SelectorTemplate from '../SelectorTemplate';
import renderFileInputField from '../../../../../../shared/components/form/FileInput';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class ECO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      data: [],
      dataMedications: [],
      specialists: [],
      specialty: '',
      professionals: [],
      professional: "",
      addedDiagnostics: [],
      openModal: false,
      loadProfessionals: false,
      loadAddedDiagnostics: false,
      vid: "",
      pp: "",
      ps: "",
      vis: "",
      fe: "",
      rao: "",
      ao: "",
      anillo_oa: "",
      vd: "",
      ai: "",
      a: "",
      e: "",
      tap_se: "",
      ad: "",
      description: "",
      conclusions: "",
      diagnostico: "",
      descripcion_d: "",
      dataPatient: [],
      age: '',
      date: new Date(),
      birthday: null,
      today: new Date(),
      day: new Date(),
      profile: sessionStorage.getItem('perfil'),
      ecoFiles: []
    }
    this.inputFileEcoRef = React.createRef(null);
  }

  componentDidMount() {
    this.getDataIndividually();
    this.setState({ addedDiagnostics: this.props.addedMedicaments, /* ecoFiles: this.props.dataProcedure.ecoFiles */ });
  }

  checkForFilesByThisProcedure = () => {
    let ecoFiles = this.props.filesProcedures.filter((file) => file.procedure === 'ECO');
    this.setState({ ecoFiles })
  }

 /*  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.dataProcedure.ecoFiles) !== JSON.stringify(this.props.dataProcedure.ecoFiles))
      //this.checkForFilesByThisProcedure();
    this.setState({ ecoFiles: this.props.dataProcedure.ecoFiles });
  } */


  /* componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.dataProcedure) !== JSON.stringify(this.props.dataProcedure)) {
      this.setState({ ecoFiles: this.props.dataProcedure.ecoFiles })
    }

  } */
  getDataIndividually = () => {

    this.setState({ loadProfessionals: true }, async () => {
      let specialistList = await this.fetchDataSpecialist();
      let professionales = await this.fetchDataProfessionals();
      console.log("specialistList", specialistList, "professionales", professionales);
      if (!!specialistList && this.props.id_professionalFromEvent !== null) {
        let id_specialty = "";
        professionales.map((professional) => {
          if (professional.id_profesional === this.props.id_professionalFromEvent) {
            id_specialty = professional.id_especialidad
          }
        });
        this.setState({ specialty: id_specialty }, () => {
          this.setState({ professional: this.props.professional, loadProfessionals: false });
          this.props.handlerMedicalProcedures("ECO", "professional", this.props.professional);
        });
      }
    })
  }

  getData = () => {
    this.setState({ loadProfessionals: true }, () => {
      Promise.all([this.fetchDataSpecialist(), this.fetchDataProfessionals()]).then((result) => {
        console.log('resultECOCKEditor', result);
        this.setState({ specialists: result[0], professionals: result[1] }, () => {
          if (this.props.professional !== null) {
            var id_specialty = "";
            result[1].map((professional) => {
              if (professional.id_profesional === this.props.professional) {
                id_specialty = professional.id_especialidad
              }
            });
            this.setState({ specialty: id_specialty }, () => {
              this.setState({ professional: this.props.professional, loadProfessionals: false });
              this.props.handlerMedicalProcedures("ECO", "professional", this.props.professional);
            });
          }
        });
      }).catch(error => console.log(`Error in promises ${error}`));
    })
  }

  fetchDataSpecialist = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'especialidad/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(specialists => {
          resolve(specialists);
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  fetchDataProfessionals = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + 'profesional/listar', {
        method: 'GET',
        headers: {
          authorization: 'Bearer ' + sessionStorage.getItem('token'),
        }
      })
        .then(response => {
          return response.json();
        })
        .then(professionals => {
          resolve(professionals);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  saveProcedure() {

    const day = new Date();
    const data = {
      id_historia: this.props.data.id_historia,
      id_admision: this.props.data.id_admision,
      fecha: moment(day).format("YYYY-MM-DD"),
      hora: moment(day).format('LT'),
      eco: {
        profesional: this.props.professional.nombres + " " + this.props.professional.apellido1,
        vid: this.state.vid,
        pp: this.state.pp,
        ps: this.state.ps,
        vis: this.state.vis,
        fe: this.state.fe,
        rao: this.state.rao,
        ao: this.state.ao,
        anillo_oa: this.state.anillo_oa,
        vd: this.state.vd,
        ai: this.state.ai,
        a: this.state.a,
        e: this.state.e,
        tap_se: this.state.tap_se,
        adult: this.state.adult,
        description: this.state.description,
        conclusions: this.state.conclusion,
        diagnostico: this.state.addedDiagnostics,
        descripcion_d: "",
      },
      stress: {
        profesional: "",
        vid: "",
        pp: "",
        ps: "",
        vis: "",
        fe: "",
        rao: "",
        anillo_oa: "",
        vd: "",
        ai: "",
        a: "",
        e: "",
        tap_se: "",
        ad: "",
        resposo: "",
        ejercicio: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      prueba: {
        professional: "",
        conclusiones: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      ekg: {
        professional: "",
        ritmo: "",
        fc: "",
        ondaP: "",
        pr: "",
        qr_s: "",
        eje_qrs: "",
        styt: "",
        qtc: "",
        conclusions: "",
        diagnostico: "",
        descripcion_d: ""
      },
      holter: {
        professional: "",
        conclusion: "",
        medicament: "",
        descripcion_d: ""
      },
      map: {
        professional: "",
        conclusion: "",
        diagnostico: "",
        descripcion_d: ""
      },
    }

    console.log(data);

    fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        alert("procedimiento creado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL + '/pages/search-clinic-history',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  handlerSpeciality = (event) => {
    this.setState({ specialty: event.target.value });
  }

  handlerProfessional = (professional) => {
    console.log(professional);
    this.setState({ professional: professional });
  }

  handlerConclusion = (conclusions) => {
    this.setState({ conclusions: conclusions });
  }

  handlerDescription = (description) => {
    this.setState({ description: description });

  }

  handlerAdult = (adult) => {
    this.setState({ adult: adult });
  }

  handlerFe = (fe) => {
    this.setState({ fe: fe });
  }

  handlerAd = (ad) => {
    this.setState({ ad: ad });
  }

  handlerAi = (ai) => {
    this.setState({ ai: ai });
  }

  handlerVis = (vis) => {
    this.setState({ vis: vis });
  }

  handlerTapse = (tap_se) => {
    this.setState({ tap_se: tap_se });
  }

  handlerVd = (vd) => {
    this.setState({ vd: vd })
  }

  handlerPs = (ps) => {
    this.setState({ ps: ps })
  }

  handlerA = (a) => {
    this.setState({ a: a });
  }

  handlerAo = (ao) => {
    this.setState({ ao: ao });
  }

  handlerPp = (pp) => {
    this.setState({ pp: pp });
  }

  handlerE = (e) => {
    this.setState({ e: e });
  }

  handlerRao = (rao) => {
    this.setState({ rao: rao });
  }

  handlerVid = (vid) => {
    this.setState({ vid: vid });
  }

  printPDF = async () => {
    await this.props.saveProceduresPatient().then((saved) => {
      if (saved) {
        PrintsProceduresPDF.printPDF(this.props.id_admision, "ECO");
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  onChangeTemplate = (template) => {
    if (template != null && template != undefined) {
      this.props.handlerMedicalProcedures("ECO", "conclusions", template.contenido, "nameTemplete", template.plantilla);
      //this.props.handlerNameTemplete("ECO", "nameTemplete", template.plantilla);
      this.handlerConclusion(template.contenido);
    }
  }

  handlerTextfieldFileProcedure = (e) => {
    console.log("WHATISTHISndTime", e);
    this.props.handlerFileProcedure(e.target.files[0], this.props.dataProcedure.id_servicio);
    //this.inputFileEcoRef.current.value = null
  }


  render() {

    const LoadFileProcedureInfo = () => {
      return (
        this.props.dataProcedure.ecoFiles.map(ecoFile => (
          <div style={{ margin: '0em 2em' }} key={ecoFile.id_procedimiento_adjunto}>
            <div>
              <b>{ecoFile.adjunto}</b>
            </div>
            <Tooltip title="Ver Documento">
              <Button
                className="btn btn-sm"
                color="primary"
                onClick={() => {
                  window.open(ecoFile.wholeUrl, '_blank');
                }}
              >
                <FontAwesomeIcon icon={faFile} />
              </Button>
            </Tooltip>
            <Tooltip title="Eliminar Documento">
              <Button
                className="btn btn-sm"
                color="danger"
                onClick={() => {
                  this.props.deleteFileProcedure(ecoFile.id_admision, ecoFile.id_servicio, ecoFile.procedure);
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt} />
              </Button>
            </Tooltip>
          </div>
        ))
      )
    }
    return (
      <Col key={this.props.filesProcedures}>
        <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
          <div className="card__title">
            <h5 className="bold-text">ECO</h5>
          </div>

          <Row>
            <Col md={6}>
              <SelectorTemplate
                typeProcedure={1}
                onChangeTemplate={(template) => {
                  this.onChangeTemplate(template);
                }}
                disabled={this.props.isCloseClinicHistory}
              />
            </Col>
          </Row>
          <br />


          <div style={{ flex: 1, flexDirection: 'row', marginBottom: 20 }}>
            <TextField
              required
              disabled
              id="specilaity-standard-required"
              label="Especialidad"
              type="text"
              value={typeof this.props.professional.especialidad === 'undefined' ? "" : this.props.professional.especialidad}
              onChange={(e) => {
                this.handlerSpeciality(e.target.value);
              }}
            />
            <TextField
              required
              disabled
              id="professional-standard-required"
              label="Profesional"
              type="text"
              value={`${this.props.professional.nombres} ${this.props.professional.apellido1}`}
              onChange={(e) => {
                this.handlerProfessional(e.target.value);
              }}
            />
          </div>

          <div className="Form">

            <div style={{ margin: 10 }}>
              <CKEditor
                style={{ width: '100%', height: '200px' }}
                editor={ClassicEditor}
                data={this.props.dataProcedure.conclusions != null ? this.props.dataProcedure.conclusions : ""}
                disabled={this.props.isCloseClinicHistory}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  this.props.handlerMedicalProcedures("ECO", "conclusions", data);
                  this.handlerConclusion(data);
                }}
              />
            </div>
          </div>
        </div>
        <Button
          style={{ marginTop: 20 }}
          color="primary"
          disabled={this.props.isCloseClinicHistory}
          onClick={() => { this.printPDF() }}
        >
          Guardar e Imprimir
        </Button>

        {!!this.props.dataProcedure.ecoFiles &&
          !!this.props.dataProcedure.ecoFiles.length ?
          <LoadFileProcedureInfo />
          : <div >
            <span className="form__form-group-label">
              Agregar adjunto
            </span>
            <div>
              <TextField
                id="file-procedure-eco-standard-required"
                type="file"
                variant="outlined"
                className="material-form__field"
                //ref={this.inputFileEcoRef}
                inputProps={{
                  multiple: false
                }}
                onChange={(e) => {
                  this.handlerTextfieldFileProcedure(e);
                }}
              />
              {/* <Field
                name="file-medical-procedure"
                component={renderFileInputField}
                onChange={(e) => {
                  console.log("WHATISHERE", e)
                  this.props.handlerFileProcedure(e, this.props.dataProcedure.id_servicio)
                }}
              /> */}
            </div>
          </div>}
      </Col>
    )
  }
}

export default ECO;
